import { render, staticRenderFns } from "./PeriodoEvaluacionSelect.vue?vue&type=template&id=122aa442"
import script from "./PeriodoEvaluacionSelect.vue?vue&type=script&lang=js"
export * from "./PeriodoEvaluacionSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports